module.exports = __webpack_public_path__ + "static/media/logo-light.51d2b894.svg";